import { todayAsString } from './dateTime'

export function isScheduled(contributionDraft: any) {
  if (!contributionDraft?.activationDate) return false
  return contributionDraft.activationDate !== todayAsString()
}

export function isEditing(contributionDraft: any) {
  return !!contributionDraft?.contribution
}